module.exports = __webpack_public_path__ + "img/blue-zen.ed258e6a.png";